import apiClient from "./api";

export interface AdjustmentItem {
  id?: number;
  product_id: number;
  product_code?: string;
  product_name?: string;
  quantity: number;
  type: 'add' | 'subtract';
  cost?: number;
  warehouse_id?: number;
  warehouse_code?: string;
  warehouse_name?: string;
}

export interface Adjustment {
  id?: number;
  ref: string;
  warehouse_id: number;
  warehouse_code: string;
  warehouse_name: string;
  date?: string;
  note?: string;
  items: AdjustmentItem[];
  created_at?: string;
  updated_at?: string;
}

export const getAdjustments = async (params: any = {}) => {
  const response = await apiClient.get("/stock-adjustments", { params });
  return response.data;
};

export const getAdjustment = async (id: string | number) => {
  const response = await apiClient.get(`/stock-adjustments/${id}`);
  return response.data.data;
};

export const createAdjustment = async (data: Partial<Adjustment>) => {
  const response = await apiClient.post("/stock-adjustments", data);
  return response.data;
};

export const updateAdjustment = async (id: string | number, data: Partial<Adjustment>) => {
  const response = await apiClient.put(`/stock-adjustments/${id}`, data);
  return response.data;
};

export const deleteAdjustment = async (id: string | number) => {
  const response = await apiClient.delete(`/stock-adjustments/${id}`);
  return response.data;
};

export const getNextReference = async () => {
  const response = await apiClient.get("/stock-adjustments/next-reference");
  return response.data.data ?? response.data;
};

export default {
  getAdjustments,
  getAdjustment,
  createAdjustment,
  updateAdjustment,
  deleteAdjustment,
  getNextReference,
};
